<script setup lang="ts">
import { computed } from "vue";
import { AppModal, appStore } from "../../stores/app";

const props = defineProps<{
    /** Which appStore.modal value opens this modal */
    name: AppModal;
    title?: string;
    /** Show the large close button outside the card */
    outerClose?: boolean;
}>();

const isOpen = computed(() => appStore.modal === props.name);

function close() {
    appStore.modal = null;
}
</script>

<!-- Bulma modal card. Clicking the background does not close it (same as before). -->
<template>
    <div class="modal" :class="{ 'is-active': isOpen }">
        <div class="modal-background"></div>
        <div class="modal-card">
            <div class="modal-card-head">
                <!-- Default header: title + close button. A "head" slot replaces it entirely. -->
                <slot name="head">
                    <div class="modal-card-title" v-html="title"></div>
                    <button class="modal-card-close delete" aria-label="close" @click="close"></button>
                </slot>
            </div>
            <section class="modal-card-body">
                <slot :close="close" />
            </section>
        </div>
        <button v-if="outerClose" class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>
</template>
